import glamorous from 'glamorous';

export default glamorous.span({color: '#80FFBB'});


// WEBPACK FOOTER //
// ./lib/components/content/Highlight.js